var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _g2, _path0, _path1, _path10, _path11, _g3, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoRevisions(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 131,
    viewBox: "0 0 181 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.4979 112.904C117.498 112.904 140.198 90.2037 140.198 62.1037C140.198 34.0037 117.398 11.3037 89.4979 11.3037C61.4979 11.3037 38.7979 34.0037 38.7979 62.1037C38.7979 90.2037 61.4979 112.904 89.4979 112.904Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.898 28.8035C139.162 28.8035 140.998 26.9679 140.998 24.7035C140.998 22.4391 139.162 20.6035 136.898 20.6035C134.633 20.6035 132.798 22.4391 132.798 24.7035C132.798 26.9679 134.633 28.8035 136.898 28.8035Z",
    fill: "#E7EBF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.898 12.8036C144.444 12.8036 145.698 11.55 145.698 10.0036C145.698 8.45722 144.444 7.20361 142.898 7.20361C141.351 7.20361 140.098 8.45722 140.098 10.0036C140.098 11.55 141.351 12.8036 142.898 12.8036Z",
    fill: "#E7EBF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4978 28.7035C43.0442 28.7035 44.2978 27.4499 44.2978 25.9035C44.2978 24.3571 43.0442 23.1035 41.4978 23.1035C39.9514 23.1035 38.6978 24.3571 38.6978 25.9035C38.6978 27.4499 39.9514 28.7035 41.4978 28.7035Z",
    fill: "#E7EBF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3978 82.7037C27.2696 82.7037 29.5978 80.3756 29.5978 77.5037C29.5978 74.6318 27.2696 72.3037 24.3978 72.3037C21.5259 72.3037 19.1978 74.6318 19.1978 77.5037C19.1978 80.3756 21.5259 82.7037 24.3978 82.7037Z",
    fill: "#E7EBF6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2447_5408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.2493 73.2124L51.31 96.7979C49.3468 98.1492 46.6719 97.6824 45.2976 95.7169L22.7696 63.2131C21.4199 61.2477 21.8862 58.5697 23.8494 57.1939L57.7886 33.6084C59.7519 32.2571 62.4268 32.7239 63.801 34.6894L86.3536 67.1932C87.7033 69.1586 87.2125 71.8611 85.2493 73.2124Z",
    fill: "url(#paint0_linear_2447_5408)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9976 69.6499L50.1565 90.3855C49.3222 90.9752 48.1688 90.7541 47.5798 89.9187L28.9537 63.0411C28.3647 62.2058 28.5856 61.051 29.42 60.4614L59.261 39.7258C60.0954 39.1362 61.2488 39.3573 61.8377 40.1926L80.4638 67.0703C81.0528 67.9056 80.8319 69.0603 79.9976 69.6499Z",
    fill: "#EAEEF9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6232 69.4285L47.7273 76.9956L48.8807 67.0454L58.6232 69.4285Z",
    fill: "#B0B7C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6293 63.164L51.948 74.0723L53.6167 59.749L67.6293 63.164Z",
    fill: "#CED6E2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5615 66.1613C45.9439 66.1613 47.0646 65.0394 47.0646 63.6554C47.0646 62.2714 45.9439 61.1494 44.5615 61.1494C43.179 61.1494 42.0583 62.2714 42.0583 63.6554C42.0583 65.0394 43.179 66.1613 44.5615 66.1613Z",
    fill: "#B0B7C4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2447_5408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.354 93.2845L94.8198 66.5542C93.0039 65.0064 92.783 62.2793 94.3045 60.4613L119.851 30.2669C121.397 28.4488 124.121 28.2277 125.937 29.751L157.471 56.4812C159.287 58.029 159.508 60.7561 157.987 62.5741L132.44 92.7685C130.894 94.5866 128.17 94.8077 126.354 93.2845Z",
    fill: "url(#paint1_linear_2447_5408)"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M128.44 87.2897L100.709 63.8025C99.924 63.1391 99.8258 61.9844 100.488 61.1982L121.593 36.2369C122.256 35.4507 123.409 35.3524 124.194 36.0158L151.925 59.503C152.71 60.1664 152.808 61.3211 152.146 62.1073L131.041 87.0686C130.379 87.8548 129.225 87.9531 128.44 87.2897Z",
    fill: "#EAEEF9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M123.115 66.5297L113.004 57.9554L122.918 56.5059L123.115 66.5297Z",
    fill: "#B0B7C4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.508 73.6301L116.931 61.2722L131.189 59.2085L131.508 73.6301Z",
    fill: "#CED6E2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M125.078 53.9753C126.46 53.9753 127.581 52.8533 127.581 51.4693C127.581 50.0853 126.46 48.9634 125.078 48.9634C123.695 48.9634 122.575 50.0853 122.575 51.4693C122.575 52.8533 123.695 53.9753 125.078 53.9753Z",
    fill: "#B0B7C4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2447_5408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.076 65.8881L71.4828 73.7068C69.1385 74.1517 66.8751 72.6146 66.4121 70.2896L58.8956 31.4589C58.4479 29.1147 59.9829 26.8535 62.308 26.3932L102.901 18.5745C105.245 18.1296 107.509 19.6667 107.972 21.9917L115.488 60.8225C115.936 63.1666 114.401 65.4278 112.076 65.8881Z",
    fill: "url(#paint2_linear_2447_5408)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.712 60.5053L73.0301 67.3926C72.021 67.5887 71.0597 66.9415 70.8624 65.9325L64.6396 33.8427C64.4423 32.8336 65.0886 31.8733 66.0977 31.6772L101.78 24.7898C102.789 24.5937 103.75 25.2409 103.947 26.25L110.17 58.3397C110.367 59.3488 109.721 60.3091 108.712 60.5053Z",
    fill: "#EAEEF9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1977 51.6434L76.1795 54.1478L81.2639 45.5139L89.1977 51.6434Z",
    fill: "#B0B7C4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9906 49.5533L81.225 53.1665L88.5532 40.7631L99.9906 49.5533Z",
    fill: "#CED6E2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6458 42.245C81.5123 41.1678 81.3404 39.5913 80.262 38.7239C79.1836 37.8565 77.6069 38.0265 76.7405 39.1037C75.874 40.1809 76.0459 41.7574 77.1243 42.6248C78.2028 43.4923 79.7794 43.3222 80.6458 42.245Z",
    fill: "#B0B7C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2447_5408",
    x: 0,
    y: 21.8379,
    width: 109.115,
    height: 108.73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2447_5408"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2447_5408",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2447_5408",
    x: 71.2954,
    y: 17.7407,
    width: 109.7,
    height: 109.554,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2447_5408"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2447_5408",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2447_5408",
    x: 36.8179,
    y: 7.49805,
    width: 100.748,
    height: 99.2856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2447_5408"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2447_5408",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2447_5408",
    x1: 54.5364,
    y1: 31.3406,
    x2: 54.5364,
    y2: 98.2662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2447_5408",
    x1: 126.124,
    y1: 27.2244,
    x2: 126.124,
    y2: 95.0014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2447_5408",
    x1: 60.4566,
    y1: 24.6638,
    x2: 113.269,
    y2: 67.1435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRevisions);
export default __webpack_public_path__ + "static/media/no-revisions.f33bb130dd6ca3fcfb126e88afb5eed3.svg";
export { ForwardRef as ReactComponent };